import { GlideFC } from "lib/glide-fc";
import ActionModal from "../../smart/action-modal/action-modal";
import WindowedModalV2 from "designer/modals-v2/windowed-modal/windowed-modal";

interface TermsOfServiceModalProps {
    termsLink: string;
    privacyLink: string;
    resolve(didAccept: boolean): void;
}

export const TermsOfServiceModal: GlideFC<TermsOfServiceModalProps> = props => {
    const { termsLink, privacyLink, resolve } = props;

    return (
        <WindowedModalV2 canClose={false} onClose={() => resolve(false)} hideClosingButton={true}>
            <ActionModal
                header={"Terms & Conditions Update"}
                description={
                    <span>
                        We've recently updated our Terms and Conditions. By clicking "Accept" you agree to Glide's{" "}
                        <a href={termsLink} title="Terms of Service" target="_blank" rel="noopener noreferrer">
                            Terms of Service
                        </a>{" "}
                        and{" "}
                        <a href={privacyLink} title="Privacy Policy" target="_blank" rel="noopener noreferrer">
                            Privacy Policy
                        </a>
                        .
                    </span>
                }
                acceptText={"Accept"}
                cancelText={"Decline"}
                acceptAction={() => resolve(true)}
                cancelAction={() => resolve(false)}
            />
        </WindowedModalV2>
    );
};
